import { motion } from "framer-motion";

const Puff = ({ delay, drift, size = 34 }) => (
  <motion.span
    className="absolute rounded-full bg-white pointer-events-none"
    style={{ width: size, height: size, left: -size / 2, top: -size / 2, filter: "blur(5px)" }}
    animate={{ y: [4, -150], x: [0, drift], scale: [0.25, 2.1], opacity: [0, 0.9, 0] }}
    transition={{
      y: { duration: 3, delay, repeat: Infinity, ease: "easeOut" },
      x: { duration: 3, delay, repeat: Infinity, ease: "easeInOut" },
      scale: { duration: 3, delay, repeat: Infinity, ease: "easeOut" },
      opacity: { duration: 3, delay, repeat: Infinity, times: [0, 0.2, 1], ease: "linear" },
    }}
  />
);

export const Sherlock = ({ className = "" }) => (
  <div data-testid="sherlock-detective" className={`pointer-events-none select-none ${className}`}>
    <img
      src="/mascot/sherlock.webp"
      alt="TPECO leak detective inspecting for hidden water leaks"
      draggable={false}
      className="w-full h-auto"
    />
    {/* pipe smoke */}
    <div className="absolute left-[76.5%] top-[58%]">
      <Puff delay={0} drift={20} />
      <Puff delay={1} drift={-16} size={26} />
      <Puff delay={2} drift={26} size={40} />
    </div>
    {/* magnifying glass sheen */}
    <div
      data-testid="sherlock-lens-sheen"
      className="absolute rounded-full overflow-hidden"
      style={{ left: "57.1%", top: "37.9%", width: "14.5%", aspectRatio: "1", transform: "translate(-50%, -50%)" }}
    >
      <motion.span
        className="absolute inset-y-[-30%] w-[34%]"
        style={{
          background: "linear-gradient(105deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)",
          rotate: 18,
        }}
        animate={{ x: ["-250%", "380%"] }}
        transition={{ duration: 1.3, repeat: Infinity, repeatDelay: 2.8, ease: "easeInOut" }}
      />
    </div>
  </div>
);
